import type { Link } from 'src/data';
import { store } from 'src/app/store';
import {
  selectNextAreaId,
  getSelectArea,
  getSelectPoint,
} from 'src/state';
import { loadAudio } from './audioUtils';

export function createPreloadAudio(audioContext: AudioContext) {
  let nextAreaId: string | null;

  function onStateChange() {
    const state = store.getState();
    const newNextAreaId = selectNextAreaId(state);

    if (nextAreaId !== newNextAreaId) {
      nextAreaId = newNextAreaId;

      if (!nextAreaId) return;

      const nextArea = getSelectArea(nextAreaId)(state);
      loadAudio(nextArea, audioContext, state);

      if (!nextArea.fields.points) return;

      nextArea.fields.points['en-US'].forEach(
        (link: Link) => {
          const pointId = link.sys.id;
          const point = getSelectPoint(pointId)(state);
          loadAudio(point, audioContext, state);
        },
      );
    }
  }

  store.subscribe(onStateChange);
  onStateChange();
}
